import random from './random';
import manual from './manual';

export { random };
export { manual }




// WEBPACK FOOTER //
// ./src/patternGenerators/index.js